<template>
  <div>
    <h5 class="text-sm font-medium tracking-wide text-gray-700 mb-2">
      Links
      <template v-if="editable">
        <button class="inline hover:underline text-blue-600 focus:outline-none" @click="addLink">
          add
        </button>
      </template>
    </h5>

    <template v-if="wip.id !== null && isExistingLink === false">
      <div class="shadow-lg rounded mb-4">
        <div class="shadow-xs rounded bg-gray-100 p-4">
          <LinkEditor
            :url.sync="wip.url"
            :title.sync="wip.title"
            :description.sync="wip.description"
            @update="commitChanges"
            @cancel="cancelEdit"
          />
        </div>
      </div>
    </template>

    <div class="mt-2 divide-y rounded-lg border overflow-hidden">
      <div v-for="(link, idx) in links" :key="link.id || idx">
        <div v-if="wip.id === link.id" class="bg-gray-100 p-4">
          <LinkEditor
            :url.sync="wip.url"
            :title.sync="wip.title"
            :description.sync="wip.description"
            @update="commitChanges"
            @cancel="cancelEdit"
          />
        </div>

        <div v-else class="px-4 py-3">
          <a
            :href="link.url"
            target="_blank"
            class="text-gray-700 text-sm font-medium hover:underline"
            v-text="link.title || link.url"
          />
          <p v-if="link.description" v-text="link.description" class="mt-2 text-sm measure" />
          <div v-if="editable" class="mt-4 space-x-2">
            <button
              class="inline hover:underline text-blue-600 text-sm focus:outline-none"
              @click="editLink(link)"
            >
              edit
            </button>
            <button
              class="inline hover:underline text-blue-600 text-sm focus:outline-none"
              @click="removeLink(link)"
            >
              remove
            </button>
          </div>
        </div>
      </div>
      <div v-if="links.length === 0" class="px-4 py-3 text-sm">
        There are no Links.
        <template v-if="editable">
          <button class="inline hover:underline text-blue-600 focus:outline-none" @click="addLink">
            Add a link.
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import LinkEditor from './relatedLinks/LinkEditor.vue';

const defaultLinkData = {
  id: null,
  url: null,
  title: null,
  description: null,
};

export default {
  name: 'RelatedLinks',

  components: {
    LinkEditor,
  },

  props: {
    editable: Boolean,
    links: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      wip: {
        ...defaultLinkData,
      },
    };
  },

  computed: {
    isExistingLink() {
      if (!this.wip.id) {
        return false;
      }

      return this.links.findIndex((link) => link.id === this.wip.id) > -1;
    },
  },

  methods: {
    editLink(link) {
      this.wip = JSON.parse(JSON.stringify(link));
    },
    addLink() {
      const newLink = JSON.parse(JSON.stringify(defaultLinkData));
      newLink.id = moment().valueOf();
      this.wip = newLink;
    },
    commitChanges() {
      const newLink = JSON.parse(JSON.stringify(this.wip));

      if (!this.isExistingLink) {
        this.$emit('update:links', [...this.links, newLink]);
      } else {
        this.$emit('update:links', [
          ...this.links.map((link) => {
            if (link.id !== this.wip.id) {
              return link;
            }

            return newLink;
          }),
        ]);
      }

      this.cancelEdit();
    },
    cancelEdit() {
      this.wip = { ...defaultLinkData };
    },
    removeLink(removeLink) {
      this.$emit('update:links', [...this.links.filter((link) => link.id !== removeLink.id)]);
    },
  },
};
</script>
